import React from 'react';
import { HeroVisual } from './illustrations/HeroVisual';
export function Hero() {
  return <section id="hero" className="min-h-screen flex items-center justify-center text-center relative z-10 pt-[140px] pb-20 px-6 overflow-hidden" data-id="element-105">
      {/* Hero Visual Background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none -z-10" data-id="element-106">
        <HeroVisual data-id="element-107" />
      </div>

      <div className="max-w-[780px] mx-auto relative z-10" data-id="element-108">
        <div className="inline-flex items-center gap-2 bg-cyan/5 border border-cyan/40 text-cyan px-[18px] py-[7px] rounded-sm text-xs font-heading font-semibold tracking-[0.15em] uppercase mb-9" data-id="element-109">
          <div className="w-[7px] h-[7px] bg-cyan rounded-sm shadow-[0_0_8px_#00e5ff] animate-pulse-dot" data-id="element-110" />
          Instagram Growth & Positioning
        </div>

        <h1 className="text-[clamp(28px,4.5vw,44px)] font-heading font-bold uppercase leading-[1.25] tracking-[0.04em] mb-6" data-id="element-111">
          Turn your Instagram into an account
          <br data-id="element-112" />
          that <span className="text-cyan text-glow" data-id="element-113">builds trust</span> and
          drives sales
        </h1>

        <p className="text-[clamp(16px,2.2vw,20px)] text-white-dim font-normal max-w-[600px] mx-auto mb-12 leading-[1.65]" data-id="element-114">
          We help brands and businesses grow on Instagram by activating the
          signals the algorithm needs to{' '}
          <strong className="text-white font-semibold" data-id="element-115">
            amplify your content, attract the right people, and convert profile
            visits into paying customers.
          </strong>
        </p>

        <div className="flex items-center justify-center flex-wrap gap-4" data-id="element-116">
          <a href="https://wa.me/12814669544?text=Hey,%20I%20want%20to%20activate%20my%20account" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 bg-cyan text-black font-heading font-bold uppercase text-[14px] px-[38px] py-4 rounded-sm decoration-transparent tracking-[0.1em] transition-all duration-300 ease-in box-glow box-glow-hover hover:bg-white hover:-translate-y-0.5" data-id="element-117">
            ⚡ Activate My Account
          </a>
          <a href="#solucion" className="inline-flex items-center gap-2.5 bg-transparent text-white-dim font-heading font-semibold uppercase text-[13px] px-[30px] py-[14px] rounded-sm border border-white/10 decoration-transparent tracking-[0.1em] transition-all duration-250 ease-in md:ml-3 hover:border-cyan hover:text-cyan" data-id="element-118">
            See How It Works ↓
          </a>
        </div>

        <div className="relative flex justify-center gap-8 md:gap-12 mt-[72px] flex-wrap p-6 rounded-lg border border-cyan/10 bg-bg-secondary/50 backdrop-blur-sm overflow-hidden" data-id="element-119">
          <div className="light-sweep" data-id="element-120" />
          <div className="text-center relative z-10" data-id="element-121">
            <span className="text-[32px] font-heading font-bold uppercase text-cyan block text-glow-sm tracking-[0.05em]" data-id="element-122">
              +300
            </span>
            <span className="text-xs font-heading text-white-dim tracking-[0.15em] uppercase mt-2 block" data-id="element-123">
              Accounts Activated
            </span>
          </div>
          <div className="text-center" data-id="element-124">
            <span className="text-[32px] font-heading font-bold uppercase text-cyan block text-glow-sm tracking-[0.05em]" data-id="element-125">
              USA
            </span>
            <span className="text-xs font-heading text-white-dim tracking-[0.15em] uppercase mt-2 block" data-id="element-126">
              Database Origin
            </span>
          </div>
          <div className="text-center" data-id="element-127">
            <span className="text-[32px] font-heading font-bold uppercase text-cyan block text-glow-sm tracking-[0.05em]" data-id="element-128">
              100%
            </span>
            <span className="text-xs font-heading text-white-dim tracking-[0.15em] uppercase mt-2 block" data-id="element-129">
              Real Interaction
            </span>
          </div>
        </div>
      </div>
    </section>;
}